import { FaWhatsapp, FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa'

const links = [
  { name: 'Tours', href: '#tours' },
  { name: 'Viajes', href: '#viajes' },
  { name: 'Opiniones', href: '#opiniones' },
  { name: 'Nosotros', href: '#Mision' },
]

const socials = [
  { href: 'https://wa.me/50239990332', icon: FaWhatsapp, label: 'WhatsApp' },
  { href: 'https://www.facebook.com/despegagt', icon: FaFacebook, label: 'Facebook' },
  { href: 'https://www.instagram.com/despegagt', icon: FaInstagram, label: 'Instagram' },
  { href: 'https://www.tiktok.com/@despega.gt', icon: FaTiktok, label: 'TikTok' },
]

export default function Footer() {
  return (
    <footer style={{ background: '#1E2578' }}>
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="flex flex-col items-center gap-8">

          <img src="logo_despega.png" alt="Despega GT" className="h-14 w-auto brightness-0 invert" />

          <nav className="flex flex-wrap justify-center gap-6">
            {links.map((l) => (
              <a key={l.name} href={l.href} className="text-sm text-white/50 hover:text-white transition">
                {l.name}
              </a>
            ))}
          </nav>

          <div className="flex gap-4">
            {socials.map(({ href, icon: Icon, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-9 h-9 flex items-center justify-center rounded-full text-white/60 hover:text-white transition hover:bg-white/10"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>

          <a
            href={`https://wa.me/50239990332?text=${encodeURIComponent('Hola, quiero cotizar un viaje con Despega GT')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 rounded-xl font-bold text-white text-sm transition hover:opacity-90"
            style={{ background: '#F5A020' }}
          >
            Cotiza tu viaje
          </a>

          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} Despega GT — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}
